function textToHTML(text) {
    if (!text) {
        return "";
    }

    const lineBreak = "\n";
    const paragraphe = text.split(`${lineBreak}${lineBreak}`);
    const htmlContent = paragraphe
        .map(
            (paragraphe) =>
                `<p>${paragraphe
                    .split(`${lineBreak}`)
                    .map((line) => `<span class="position-block">${line}</span>`)
                    .join("")}</p>`
        )
        .join("");

    return htmlContent;
}

function slugify(text) {
    return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function formatDateTime(dateTimeString, options = { dateStyle: "medium", timeStyle: "medium" }) {
    if (!dateTimeString) {
        return '';
    }

    return dateTimeString.toLocaleString("fr", options)
}

function formatPrice(price) {
    if (isNaN(price)) {
        return "--,-- €"
    }
    return (Number.parseFloat(price).toFixed(2).replace(".", ",") + " €").replace('-', '- ')
}

function safeJsonParse(value, fallback = undefined) {
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
}

export { textToHTML, slugify, formatDateTime, formatPrice, safeJsonParse }